import type { GTooltipCardData } from '~/presentation/ui';

import { IPlanToolTipKey } from '../types/plan-tooltip';

export const PLAN_TOOLTIP: Record<IPlanToolTipKey, GTooltipCardData> = {
  [IPlanToolTipKey.RECORDED_REVENUE]: {
    title: 'Recorded revenue',
    content:
      'Revenue is calculated based on GemX data: Total income generated from sales after discounts',
    formula: (
      <>
        <span className="formula-variable">Revenue</span>
        <span> = </span>
        <span className="formula-input">gross sales - discounts</span>
      </>
    ),
    width: 'large',
  },
  [IPlanToolTipKey.SUBSCRIPTION]: {
    title: 'Subscription',
    content: 'Subscription will be charged on every 30 days.',
    width: 'wide',
  },
  [IPlanToolTipKey.USAGE_FEE]: {
    title: 'Usage fee',
    content:
      'Usage fee is calculated based on the actual revenue recorded each month and will be billed at the beginning of the following month.',
    width: 'wide',
  },
  [IPlanToolTipKey.TEMPLATE_TESTING]: {
    title: 'Template testing',
    content:
      'Experiment with layouts, content, and design - testing everything from CTAs, words, and elements to full pages and sections.',
    width: 'wide',
  },
  [IPlanToolTipKey.PRODUCT_PRICE_TESTING]: {
    title: 'Product price testing',
    content:
      'Test two prices at once to find the highest price your buyers will accept. No Shopify Plus required.',
    width: 'wide',
  },
  [IPlanToolTipKey.MULTIPAGE_TESTING]: {
    title: 'Multipage testing',
    content:
      'Test multiple pages or the whole site to understand what truly impacts conversions at every step of the funnel.',
    width: 'wide',
  },
  [IPlanToolTipKey.PATH_ANALYSIS]: {
    title: 'Journey analysis',
    content:
      'Journey analysis tracks the journey from entry to purchase and shows where visitors leave the store.',
    width: 'wide',
  },
  [IPlanToolTipKey.HEATMAP]: {
    title: 'Heatmap',
    content: 'Heatmap tracks the heat of the page and shows where visitors click on the page.',
    width: 'wide',
  },
  [IPlanToolTipKey['60DAYS']]: {
    title: '60 days',
    content: 'Data is stored for 60 days, with a maximum date filter range of 30 days.',
    width: 'wide',
  },
  [IPlanToolTipKey['2YEARS']]: {
    title: '2 years',
    content: 'Data is stored for 2 years, with a maximum date filter range of 365 days.',
    width: 'wide',
  },
};
